// React
import React, { Component } from "react";
// Redux
import { connect } from "react-redux";
import { compose } from "redux";
// Router
import { replace } from "react-router-redux";
import { reduxForm } from "redux-form";
import { withNamespaces } from "react-i18next";
import { BASE_URL } from "../../config/constants";
// Form
// Ducks
import { changeProfile } from "./ProfileChange.ducks";
import { fetchAppFeatureSettings } from "../../services/clientSettings.ducks";
import { fetchProfile } from "../../services/auth.ducks";
// Components
import Form from "../../components/Form";
import ProfileFields from "../../components/ProfileFields";
// i18n

class ProfileChange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enableUserDataEdit: true,
      locales: props.locales,
      isoCountries: props.isoCountries
    };
  }

  async UNSAFE_componentWillMount() {
    const { auth, fetchProfile } = this.props;
    if (!auth.profile.email) {
      fetchProfile();
    }

    !this.props.auth.profile.isProfileIntendedToApprove &&
      this.props.replace(`${BASE_URL}/dashboard`);

    const { fetchAppFeatureSettings } = this.props;
    const appFeatureSettings = await fetchAppFeatureSettings();

    this.setState({
      enableUserDataEdit: appFeatureSettings.enableUserDataEdit
    });
  }

  onSubmit = (values) => {
    this.props.changeProfile(values);
  };

  getPreferredCommunicationLanguageOptions = () => {
    const { locales } = this.state;
    const options = [];

    locales.forEach((locale) => {
      options.push({
        key: locale.locale,
        value: locale.localeName
      });
    });

    options.sort((a, b) => {
      return a.value.localeCompare(b.value);
    });

    return options;
  };

  getIsoCountryOptions = () => {
    const { t } = this.props;
    const { isoCountries } = this.state;
    const options = [];

    isoCountries.forEach((isoCountry) => {
      options.push({
        key: isoCountry.isoCountryAlpha3,
        value: t(isoCountry.nameL10n)
      });
    });

    options.sort((a, b) => {
      return a.value.localeCompare(b.value);
    });

    return options;
  };

  render() {
    const { handleSubmit, t } = this.props;
    const { enableUserDataEdit } = this.state;

    return (
      <div className="container">
        <Form
          bootStrapClass="col-sm-6 col-sm-offset-3  well no-padding"
          handleSubmit={handleSubmit}
          onSubmit={this.onSubmit}
          title={t("modules.localization.register.authenticated.profileChange.firstTimeProfile")}
        >
          <ProfileFields
            fieldNames={{
              birthDate: t("modules.localization.register.authenticated.settings.birthDate"),
              city: t("modules.localization.register.authenticated.settings.city"),
              isoCountryAlpha3: t("modules.localization.register.authenticated.settings.country"),
              emailLanguage: t(
                "modules.localization.register.authenticated.settings.emailLanguage"
              ),
              firstName: t("modules.localization.register.authenticated.settings.firstName"),
              lastName: t("modules.localization.register.authenticated.settings.lastName"),
              postalCode: t("modules.localization.register.authenticated.settings.postalCode"),
              street: t("modules.localization.register.authenticated.settings.street"),
              street2: t("modules.localization.register.authenticated.settings.street2")
            }}
            languagesOptions={this.getPreferredCommunicationLanguageOptions()}
            isoCountryOptions={this.getIsoCountryOptions()}
            options={{ enableUserDataEdit: enableUserDataEdit }}
          />
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  initialValues: state.auth.profile.email ? state.auth.profile : undefined,
  locales: state.localization.locales,
  isoCountries: state.internationalization.isoCountries
});

export default compose(
  connect(
    mapStateToProps,
    { changeProfile, replace, fetchProfile, fetchAppFeatureSettings }
  ),
  reduxForm({
    form: "profileChange"
  }),
  withNamespaces()
)(ProfileChange);
